import React from 'react';

const SignupStepHeader = ({ steps, currentStepKey }) => {
  const currentIndex = steps.findIndex(s => s.key === currentStepKey);

  return (
    <div className="flex items-center w-full">
      {steps.map((step, index) => {
        const isActive = step.key === currentStepKey;
        const isCompleted = index < currentIndex;

        return (
          <React.Fragment key={step.key}>
            {/* Step bubble + label */}
            <div className="flex flex-col items-center flex-shrink-0">
              <div
                className={`
                  w-7 h-7 rounded-full flex items-center justify-center text-xs font-semibold
                  transition-all duration-200
                  ${isActive ? 'bg-[#0071e3] text-white shadow-[0_0_0_3px_rgba(0,113,227,0.18)]' : ''}
                  ${isCompleted ? 'bg-[#34c759] text-white' : ''}
                  ${!isActive && !isCompleted ? 'border border-[#d2d2d7] text-[#86868b] bg-white' : ''}
                `}
              >
                {isCompleted ? (
                  <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  step.stepNumber
                )}
              </div>
              <span
                className={`
                  mt-1.5 text-[11px] font-medium whitespace-nowrap tracking-wide
                  ${isActive ? 'text-[#0071e3]' : isCompleted ? 'text-[#34c759]' : 'text-[#86868b]'}
                `}
              >
                {step.label}
              </span>
            </div>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={`
                  flex-1 h-px mx-2 mb-5 transition-colors duration-300
                  ${index < currentIndex ? 'bg-[#34c759]' : 'bg-[#d2d2d7]'}
                `}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SignupStepHeader;
